import { Edit } from '@mui/icons-material';
import { Box, CircularProgress, Grid, IconButton } from '@mui/material';
import React from 'react';

export const EditableFieldWrapper = ({
  edit,
  onEditClick,
  isLoading,
  serviceId,
  children,
}) => (
  <Grid container alignItems="center">
    {children}
    <Grid item>
      {isLoading ? (
        <Box p={1} data-testid="loadingSpinner">
          <CircularProgress
            sx={{ color: theme => theme.palette.text.secondary }}
            size={20}
            thickness={6}
          />
        </Box>
      ) : (
        <IconButton onClick={onEditClick} data-testid="edit-btn">
          <Edit fontSize="small" />
        </IconButton>
      )}
    </Grid>
  </Grid>
);
